import { createSelector } from 'reselect';

const getSearchStore = state => state.searchStore;
const searchItems = createSelector(getSearchStore, ({ items: { data = [] } }) => data);
const searchStatus = createSelector(getSearchStore, ({ items: { status } }) => status);

export { searchItems, searchStatus };
